import styled from 'styled-components'

import { COLOURS } from 'resources'
import { ReactComponent as ReklaimWordmark } from 'resources/images/brand/reklaim-wordmark.svg'

export const ImageIconContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;
  flex: 1;
`

export const LeftSideBackground = styled.div`
  background-image: url(${({ background }) => background});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

export const ReklaimWordmarkYellow = styled(ReklaimWordmark)`
  position: absolute;
  align-self: flex-end;
  width: 160px;
  height: auto;
  margin: 45px;

  path {
    fill: ${COLOURS.primaryYellow};
  }
`

export const IconTextContainer = styled.div`
  padding: 50px 50px 0;
  height: 100%;
`

export const ReklaimWordmarkWhite = styled(ReklaimWordmark)`
  position: absolute;
  right: 0;
  align-self: flex-end;
  width: 135px;
  height: auto;
  margin: 30px 25px;

  path {
    fill: ${COLOURS.white};
  }
`

export const FeaturedImageAlignedBottom = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 30px;
`

export const FeaturedImageAlignedTop = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 30px;
`

export const TopUnveilScribble = styled.img`
  position: absolute;
  top: -65px;
  right: -55px;
  width: 200px;
  transform: rotate(105deg);
`

export const TopUnveilRotatedScribble = styled.img`
  position: absolute;
  top: -65px;
  right: -55px;
  width: 200px;
  transform: rotate(30deg);
`

export const ContainerFlex = styled.div`
  flex: 1;
  position: relative;
`
// Create Account Explainer
export const AttributesContainer = styled.div`
  padding-top: 50px;
`

export const ReklaimWordmarkWhiteLeft = styled(ReklaimWordmark)`
  position: absolute;
  align-self: flex-start;
  width: 135px;
  height: auto;
  margin: 60px 50px;

  path {
    fill: ${COLOURS.white};
  }
`

export const Title = styled.div`
  font-family: 'Druk', sans-serif;
  font-size: 60px;
  line-height: 1;
  color: ${COLOURS.neutralWhite};
`

export const AttributesCountContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 50px;
`
export const AttributesLabelContainer = styled.div`
  display: flex;
  align-items: center;
`

export const AttributesValueContainer = styled.div``

export const Icon = styled.i`
  font-size: 40px;
  color: ${COLOURS.primaryYellow};
  margin-right: 5px;
`

export const AttributesText = styled.div`
  font-family: 'Druk', sans-serif;
  font-size: 60px;
  line-height: 1;
  color: ${COLOURS.white};
`
export const AttributesLabel = styled.div`
  font-size: 20px;
  color: ${COLOURS.neutralWhite};
`
